import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestDenominazioneEditComponent.vue?vue&type=template&id=3b7f64df&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestDenominazioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestDenominazioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestDenominazioneEditComponent.vue?vue&type=style&index=0&id=3b7f64df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f64df",
  null
  
)

export default component.exports